import request from '@/utils/request'

// 获取分配手动用户列表
export function getUnallocatedUserList(params) {
  return request({
    url: '/manual/customer/getUnallocatedUserList',
    method: 'get',
    params,
  })
}

// 指派手动卡主给客服
export function assignKefu(data) {
  return request({
    url: '/manual/customer/assignKefu',
    method: 'post',
    data,
  })
}

// 取消指派手动卡主给客服
export function unassignKefu(id) {
  return request({
    url: `/manual/customer/unassignKefu/${id}`,
    method: 'delete',
  })
}

// 更新手动卡主 EnigmaID
export function updateEnigmaId(data) {
  return request({
    url: '/manual/customer/updateEnigmaId',
    method: 'post',
    data,
  })
}

// 开始接单
export function startTakeOrder(data) {
  return request({
    url: '/manual/customer/startTakeOrder',
    method: 'post',
    data,
  })
}

// 停止接单
export function stopTakeOrder(data) {
  return request({
    url: '/manual/customer/stopTakeOrder',
    method: 'post',
    data,
  })
}

// 更新帐户接单状态
export function updateAccountTakeOrderStatus(data) {
  return request({
    url: '/manual/customer/updateAccountTakeOrderStatus',
    method: 'post',
    data,
  })
}

// 更新用户接单状态
export function updateUserTakeOrderStatus(data) {
  return request({
    url: '/manual/customer/updateUserTakeOrderStatus',
    method: 'post',
    data,
  })
}

// 获取订单记录列表
export function getOrderRecordList(params) {
  return request({
    url: '/manual/customer/getOrderRecordList',
    method: 'get',
    params,
  })
}

// 开启新的一期接单
export function startTakeOrderPeriod(data) {
  return request({
    url: '/manual/customer/startTakeOrderPeriod',
    method: 'post',
    data,
  })
}

// 结束当期接单
export function endTakeOrderPeriod(id) {
  return request({
    url: `/manual/customer/endTakeOrderPeriod/${id}`,
    method: 'post',
  })
}

// 更新调整馀额
export function updateAdjustBalance(data) {
  return request({
    url: '/manual/customer/updateAdjustBalance',
    method: 'post',
    data,
  })
}

// 获取订单信息记录列表
export function getOrderMessageRecordList(params) {
  return request({
    url: '/manual/customer/getOrderMessageRecordList',
    method: 'get',
    params,
  })
}

// 调整平台余额
export function adjustBalance(data) {
  return request({
    url: '/manual/customer/adjustBalance',
    method: 'post',
    data,
  })
}

// 获取纯手动卡主平台馀额账变表
export function listManualCustomerPlatformBalanceChangeDetails(params) {
  return request({
    url: '/manual/customer/listManualCustomerPlatformBalanceChangeDetails',
    method: 'get',
    params,
  })
}

// 未知暂存支付到帐
export function unKnownPaidOrder(data) {
  return request({
    url: '/manual/customer/unKnownPaidOrder',
    method: 'post',
    data,
  })
}

// 批次取消指派客服给手动卡主
export function batchUnassignKefu(data) {
  return request({
    url: '/manual/customer/batchUnassignKefu',
    method: 'delete',
    data,
  })
}

// 标记订单暂扣, 先计算卡主相关不回调
export function makeOrderPayedForKZ(data) {
  return request({
    url: '/manual/customer/makeOrderPayedForKZ',
    method: 'post',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/api/manual.js